import { Pressable, StyleSheet, Text, View } from 'react-native';

import { Fonts, Palette } from '@/constants/theme';
import { webTransition } from '@/lib/hover-style';

export function SectionLabel({
  title,
  hint,
  onHintPress,
}: {
  title: string;
  hint?: string;
  /** When provided, the hint renders as a tappable forest-tinted link
   *  instead of a static label. Used on My Home so "31 systems" can
   *  jump straight into the dedicated /systems page. */
  onHintPress?: () => void;
}) {
  const hintNode = hint ? (
    onHintPress ? (
      <Pressable
        onPress={onHintPress}
        hitSlop={6}
        style={({ pressed, hovered }) => [
          styles.hintBtn,
          webTransition,
          hovered && { opacity: 0.75 },
          pressed && { opacity: 0.55 },
        ]}>
        <Text style={[styles.hint, styles.hintTappable]}>{hint} ›</Text>
      </Pressable>
    ) : (
      <Text style={styles.hint}>{hint}</Text>
    )
  ) : null;
  return (
    <View style={styles.row}>
      <Text style={styles.title}>{title}</Text>
      {hintNode}
    </View>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    paddingHorizontal: 24,
    marginTop: 22,
    marginBottom: 10,
  },
  title: {
    fontFamily: Fonts.serifBold,
    fontSize: 15,
    color: Palette.ink,
    letterSpacing: -0.2,
  },
  hint: {
    fontSize: 12.5,
    color: Palette.inkFaint,
    fontFamily: Fonts.sansSemibold,
  },
  hintBtn: {
    // hitSlop adds the real touch area — the visual element stays
    // compact so the hint doesn't visually compete with the title.
  },
  hintTappable: {
    color: Palette.forest,
  },
});
